import './options-toolbar.scss'

import { Component, Watch } from 'vue-property-decorator'
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons'

import { SearchParams, SortFilter } from '@skinsoft/types'
import { EntityFieldDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

interface SortOption {
    label: string
    values: string[]
}

@Component({
    props: ['sortingEntityFields'],
    template: require('./options-toolbar.html'),
})
export class OptionsToolbar extends ReactiveVue {

    public sortingEntityFields: SortFilter[]

    private $entityFieldDataStore: EntityFieldDataStore

    private sortOptions: SortOption[] = []
    private selectSortIndex: number = -1 // we set to -1 by default to trigger update after sortOptions are loaded 

    // Icons
    private sortAscIcon = faSortAmountUp;
    private sortDescIcon = faSortAmountDown;

    private options: Partial<SearchParams> = {
        sortAsc: false,
        sortType: [''],
    };

    public async populateSelectOptions() {
        this.sortOptions = []

        // Setting options from config file
        for (const [index, sortConfs] of this.sortingEntityFields?.entries()) {
            const entityFieldsIds: string[] = []

            for(const sortConf of sortConfs.entityFields) {
                try { // the try catch is to continue on error and not fail for all entityFields if one fail
                    if(sortConf.id) {
                        entityFieldsIds.push(sortConf.id)
                    } 
                    else if(sortConf.entityFieldName && sortConf.entityName && sortConf.schemaName) {
                        const entityFieldId = await this.$entityFieldDataStore.getEntityFieldId(
                            sortConf.entityFieldName,
                            sortConf.entityName,
                            sortConf.schemaName
                        )
                        entityFieldsIds.push(entityFieldId)
                    }

                } catch(err) {
                    //console.log(err)
                }
            }

            this.sortOptions.push({
                label: sortConfs.i18nKey,
                values: entityFieldsIds
            })
        }

        // Setting default sort option (first in config file)
        if (this.sortOptions.length) {
            this.selectSortIndex = 0 // to trigger update
        }
    }
    private toggleSortAsc() {
        this.options.sortAsc = !this.options.sortAsc
        this.$emit('change', this.options)
    }

    @Watch('selectSortIndex', { immediate: true, deep: true })
    private onValueChange() {
        if(this.sortOptions?.[this.selectSortIndex]?.values?.length) {
            this.options.sortType = this.sortOptions[this.selectSortIndex].values
            this.$emit('change', this.options)
        }
    }

    @Watch('sortingEntityFields')
    private onSortingEntityFieldsChange() {
        this.populateSelectOptions()
    }
}
